import React from 'react'
import { createRoot } from 'react-dom/client'
import { Application } from './components/Application'

export let startOrderAccessCodesApp = () => {
  const root = createRoot(document.getElementById('order-access-codes-app'))
  root.render(<Application />)
}
